import React from "react";
import { Link } from "react-router-dom";
import { isAuthenticate } from "../auth/helper";
import Base from "../core/Base";

const AdminDashBoard = () => {
  const {
    user: { name, email },
  } = isAuthenticate();

  const adminLeftSide = () => {
    return (
      <div className="card">
        <h4 className="card-header bg-dark text-white">Admin Navigation</h4>
        <ul className="list-group">
          <li className="list-group-item ">
            <Link
              to="/admin/create/category"
              className="nav-link text-center text-success"
            >
              Create Category
            </Link>
          </li>
          <li className="list-group-item ">
            <Link
              to="/admin/categories"
              className="nav-link text-center text-success"
            >
              Manage Categories
            </Link>
          </li>
          <li className="list-group-item ">
            <Link
              to="/admin/create/Product"
              className="nav-link text-center text-success"
            >
              Create Product
            </Link>
          </li>
          <li className="list-group-item ">
            <Link
              to="/admin/products"
              className="nav-link text-center text-success"
            >
              Manage Product
            </Link>
          </li>
          <li className="list-group-item ">
            <Link
              to="/admin/orders"
              className="nav-link text-center text-success"
            >
              Manage Order
            </Link>
          </li>
        </ul>
      </div>
    );
  };

  const adminRightSide = () => {
    return (
      <div className="card md-4">
        <h4 className="card-header">Admin Information</h4>
        <ul className="list-group">
          <li className="list-group-item">
            <span className="badge badge-success mr-2">Name:</span>{name}
          </li>
          <li className="list-group-item">
            <span className="badge badge-success mr-2">Email:</span>{email}
          </li>
          <li className="list-group-item">
            <span className="badge badge-danger mr-2">Admin Dashboard</span>
          </li>
        </ul>
      </div>
    )
  };

  return (
    <Base
      title="Welcome to Admin Dashboard"
      description="Manage all of your Products Here"
      className="container bg-success rounded p-4"
    >
      <div className="row">
        <div className="col-3">{adminLeftSide()}</div>
        <div className="col-9">{adminRightSide()}</div>
      </div>
    </Base>
  );
};

export default AdminDashBoard;
